"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _utils = _interopRequireDefault(require("../../../../utils"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _RmName = _interopRequireDefault(require("../../../../RmName.json"));

var _axios = _interopRequireDefault(require("axios"));

var _errorPage = _interopRequireDefault(require("../../../error-views/errorPage"));

var _MathTableData = _interopRequireDefault(require("./MathTableData"));

var _EngTableData = _interopRequireDefault(require("./EngTableData"));

var _parentData = _interopRequireDefault(require("./parentData"));

var _AuditForm = _interopRequireDefault(require("./AuditForm"));

var _CardData = _interopRequireDefault(require("./CardData"));

var _MathsData = _interopRequireDefault(require("./MathsData"));

var _EnglishData = _interopRequireDefault(require("./EnglishData"));

var innerwidth = window.innerWidth;
var date = new Date(); // let year = date.getFullYear();
// let month = ("0" + (date.getMonth() + 1)).slice(-2);

var dateday = ("0" + date.getDate()).slice(-2); // let day = date.getDay();
// let temp = `${year}-${month}-${dateday}`;

var tableColumns = [{
  title: 'RM Name',
  dataIndex: 'RM_Name',
  key: 'RM_Name',
  render: function render(text, record) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
      size: 30,
      className: "font-size-sm",
      style: {
        backgroundColor: '#04d182'
      }
    }, _utils.default.getNameInitial(text)), /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2"
    }, text));
  },
  sorter: function sorter(a, b) {
    return _utils.default.antdTableSorter(a, b, 'RM_Name');
  }
}, {
  title: _RmName.default.name,
  dataIndex: 'RMcode',
  key: 'RMcode',
  sorter: function sorter(a, b) {
    return _utils.default.antdTableSorter(a, b, 'RMcode');
  }
}, {
  title: 'Reason',
  dataIndex: 'Reason',
  key: 'Reason',
  sorter: function sorter(a, b) {
    return _utils.default.antdTableSorter(a, b, 'Reason');
  }
}, {
  title: function title() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "text-right"
    }, "Status");
  },
  key: 'Status',
  render: function render(_, record) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "text-right"
    }, /*#__PURE__*/_react.default.createElement(_antd.Tag, {
      className: "mr-0",
      color: record.Status === 'Present' ? 'cyan' : record.Status === 'Absent' ? 'volcano' : 'blue'
    }, record.Status));
  },
  sorter: function sorter(a, b) {
    return _utils.default.antdTableSorter(a, b, 'Status');
  }
}];

var Audit = function Audit() {
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      RMCode = _useState2[0],
      setRMCode = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      RMMathAuditDone = _useState4[0],
      setRMMathAuditDone = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      RMEngAuditDone = _useState6[0],
      setRMEngAuditDone = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      ParentAuditDone = _useState8[0],
      setParentAuditDone = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      RMData = _useState10[0],
      setRMData = _useState10[1]; //RM for Today


  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      tableDataRMs = _useState12[0],
      setTableDataRMs = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      alltableDataRMs = _useState14[0],
      setAllTableDataRMs = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      showTable = _useState16[0],
      setshowTable = _useState16[1]; // const [showEngTable, setshowEngTable] = useState(false);


  var _useState17 = (0, _react.useState)("Audit"),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      showTableHeading = _useState18[0],
      setshowTableHeading = _useState18[1];

  var _useState19 = (0, _react.useState)(false),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      showScoreData = _useState20[0],
      setShowScoreData = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      showFormData = _useState22[0],
      setShowFormData = _useState22[1];

  var _useState23 = (0, _react.useState)([]),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      mathParentdata = _useState24[0],
      setMathParentData = _useState24[1];

  var _useState25 = (0, _react.useState)([]),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      engParentdata = _useState26[0],
      setEngParentData = _useState26[1];

  var _useState27 = (0, _react.useState)(false),
      _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
      showParent = _useState28[0],
      setshowParent = _useState28[1];

  var _useState29 = (0, _react.useState)(''),
      _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
      subject = _useState30[0],
      setSubject = _useState30[1];

  var _useState31 = (0, _react.useState)(null),
      _useState32 = (0, _slicedToArray2.default)(_useState31, 2),
      apiError = _useState32[0],
      setapiError = _useState32[1];

  var _useState33 = (0, _react.useState)(true),
      _useState34 = (0, _slicedToArray2.default)(_useState33, 2),
      loading = _useState34[0],
      setLoading = _useState34[1]; // useEffect(async () => {
  //   RMMathAudit();
  //   // RMEngAudit();
  // }, []);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                RMMathAudit();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, []);

  function getRMForToday() {
    return _getRMForToday.apply(this, arguments);
  }

  function _getRMForToday() {
    _getRMForToday = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var url;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = _config.default.getRM + cl;
              _context2.next = 3;
              return _axios.default.get(url, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);

                if (resp.data.length > 0) {
                  setRMData(resp.data);
                  if (resp.data[0].rmauditpercent) setRMMathAuditDone(true);
                  if (resp.data[0].RMAuditPercentEnglish) setRMEngAuditDone(true);
                  if (resp.data[0].parentauditpercent) setParentAuditDone(true);
                  setLoading(false);
                }
              }, function (error) {
                setapiError(error.response);
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _getRMForToday.apply(this, arguments);
  }

  function getabsent() {
    return _getabsent.apply(this, arguments);
  }

  function _getabsent() {
    _getabsent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var url1;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url1 = _config.default.getabsentRMForAudit + cl;
              _context3.next = 3;
              return _axios.default.get(url1, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);
                setTableDataRMs(resp.data);
                setAllTableDataRMs(resp.data);
                getRMForToday(); // setLoading(false)
              }, function (error) {
                setapiError(error.response);
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _getabsent.apply(this, arguments);
  }

  function RMMathAudit() {
    return _RMMathAudit.apply(this, arguments);
  }

  function _RMMathAudit() {
    _RMMathAudit = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var url1, url2, url;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url1 = _config.default.getRMMathsDataForNextFifteen + cl;
              url2 = _config.default.getRMAuditMathsData + cl;

              if (dateday < 15) {
                url = url2;
              } else {
                url = url1;
              }

              _context4.next = 5;
              return _axios.default.get(url).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);
                setMathParentData(resp.data);
                RMEngAudit(); // setLoading(false);
              }, function (error) {
                setapiError(error.response);
              });

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _RMMathAudit.apply(this, arguments);
  }

  function RMEngAudit() {
    return _RMEngAudit.apply(this, arguments);
  }

  function _RMEngAudit() {
    _RMEngAudit = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var url1, url2, url;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              url1 = _config.default.getRMEngDataForNextFifteen + cl;
              url2 = _config.default.getRMAuditEngData + cl;

              if (dateday < 15) {
                url = url2;
              } else {
                url = url1;
              }

              _context5.next = 5;
              return _axios.default.get(url).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);
                setEngParentData(resp.data);
                getabsent(); // setLoading(false);
              }).catch(function (err) {
                setapiError(err.response);
              });

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _RMEngAudit.apply(this, arguments);
  }

  var onSearch = function onSearch(e) {
    var value = e.currentTarget.value;

    var searchdata = _utils.default.wildCardSearch(alltableDataRMs, value);

    setTableDataRMs(searchdata);
  };

  var showTableData = function showTableData(str) {
    if (str === 'Math') {
      setSubject(str); // RMMathAudit();

      setRMCode(RMData[0].rmcode);
      setshowTableHeading("".concat(_RmName.default.rm, " Maths Audit"));
      setshowTable(true);
    } else {
      setSubject(str); // RMEngAudit();

      setRMCode(RMData[0].RMcodeEnglish);
      setshowTableHeading("".concat(_RmName.default.rm, " English Audit"));
      setshowTable(true);
    }
  };

  var showParentAudit = function showParentAudit() {
    setshowTableHeading("Parent Audit");
    setshowParent(!showParent);
  };

  var showScore = function showScore() {
    setShowScoreData(!showScoreData);
  };

  var showForm = function showForm() {
    setShowFormData(!showFormData);
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement("h3", null, showTableHeading)))), showTable ? subject === 'English' ? engParentdata.length === 0 ? (alert("No Parent Data Found for English Audit"), window.location = "/clPortal/app/rm/audit") : innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_EngTableData.default, {
    parentdata1: engParentdata,
    RMCode: RMCode,
    subject: subject,
    onChangeHeading: function onChangeHeading() {
      return setshowTableHeading("Audit");
    }
  }) : /*#__PURE__*/_react.default.createElement(_EnglishData.default, {
    parentdata1: engParentdata,
    RMCode: RMCode,
    subject: subject,
    onChangeHeading: function onChangeHeading() {
      return setshowTableHeading("Audit");
    }
  }) : mathParentdata.length === 0 ? (alert("No Parent Data Found for Maths Audit"), window.location = "/clPortal/app/rm/audit") : innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_MathTableData.default, {
    parentdata1: mathParentdata,
    RMCode: RMCode,
    subject: subject,
    onChangeHeading: function onChangeHeading() {
      return setshowTableHeading("Audit");
    }
  }) : /*#__PURE__*/_react.default.createElement(_MathsData.default, {
    parentdata1: mathParentdata,
    RMCode: RMCode,
    subject: subject,
    onChangeHeading: function onChangeHeading() {
      return setshowTableHeading("Audit");
    }
  }) : showParent ? /*#__PURE__*/_react.default.createElement(_parentData.default, {
    RMCode: RMData.length > 0 ? RMData[0].rmcode : ""
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "CR Audit"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 18,
    lg: 18,
    xl: 18,
    xxl: 18
  }, /*#__PURE__*/_react.default.createElement("h3", null, _RmName.default.nameCode, " for Maths :", RMData.length > 0 ? RMData[0].rmcode : "No RM Selected"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, _RmName.default.name, " Maths \u0911\u0921\u093F\u091F \u0915\u0947  \u0932\u093F\u090F \u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947 \u0964"))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 6,
    xxl: 6
  }, RMMathAuditDone ? /*#__PURE__*/_react.default.createElement(_icons.CheckCircleOutlined, {
    style: {
      color: '#36cfc9',
      fontSize: 60
    }
  }) : /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    onClick: function onClick() {
      return showTableData("Math");
    }
  }, "Click here!")))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "CR Audit"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 18,
    xl: 18,
    xxl: 18
  }, /*#__PURE__*/_react.default.createElement("h3", null, _RmName.default.nameCode, " for English : ", RMData.length > 0 ? RMData[0].RMcodeEnglish : "No RM Selected"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, _RmName.default.name, " English \u0911\u0921\u093F\u091F \u0915\u0947  \u0932\u093F\u090F \u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947 \u0964"))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 6,
    xxl: 6
  }, RMEngAuditDone ? /*#__PURE__*/_react.default.createElement(_icons.CheckCircleOutlined, {
    style: {
      color: '#36cfc9',
      fontSize: 60
    }
  }) : /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    onClick: function onClick() {
      return showTableData("English");
    }
  }, "Click here!")))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Parent Audit"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 18,
    xl: 18,
    xxl: 18
  }, /*#__PURE__*/_react.default.createElement("h3", null, _RmName.default.nameCode, " for Parent Audit : ", RMData.length > 0 ? RMData[0].rmcode : "No RM Selected"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Parent \u0911\u0921\u093F\u091F \u0915\u0947  \u0932\u093F\u090F \u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947 \u0964"))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 6,
    xxl: 6
  }, ParentAuditDone ? /*#__PURE__*/_react.default.createElement(_icons.CheckCircleOutlined, {
    style: {
      color: '#36cfc9',
      fontSize: 60
    }
  }) : /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    onClick: function onClick() {
      return showParentAudit();
    }
  }, "Click here!")))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Audit Score"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 18,
    xl: 18,
    xxl: 18
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Score \u0915\u0947  \u0932\u093F\u090F \u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947 \u0964"))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 6,
    xl: 6,
    xxl: 6
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    onClick: showScore
  }, "Click here!")))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24,
    key: 1
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "No Audit Response Form"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 18,
    xl: 18,
    xxl: 18
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Form \u0915\u0947  \u0932\u093F\u090F \u092F\u0939\u093E\u0901 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947 \u0964"))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 6
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    onClick: showForm
  }, "Click here!"))))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 12
  }, innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Unavailable RMs",
    style: {
      height: 830
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    style: {
      width: '100%'
    },
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    }
  }), tableDataRMs.length > 0 ? /*#__PURE__*/_react.default.createElement(_antd.Table, {
    className: "no-border-last",
    columns: tableColumns,
    dataSource: tableDataRMs,
    rowKey: "RM_code",
    style: {
      overflowY: 'scroll',
      height: 590
    },
    pagination: false
  }) : /*#__PURE__*/_react.default.createElement(_antd.Empty, null)) : /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Unavailable RMs",
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    style: {
      width: '100%'
    },
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    }
  }), tableDataRMs.length > 0 ? /*#__PURE__*/_react.default.createElement(_CardData.default, {
    data: tableDataRMs
  }) : /*#__PURE__*/_react.default.createElement(_antd.Empty, null)))), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Audit Score",
    visible: showScoreData,
    onOk: showScore,
    cancelButtonProps: {
      hidden: true
    },
    onCancel: function onCancel() {
      return setShowScoreData(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 14,
    sm: 14,
    md: 14,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Math ", _RmName.default.name, " Audit : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 10,
    sm: 10,
    md: 10,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    className: "mr-0",
    color: RMData.length > 0 ? RMData[0].rmauditpercent ? 'cyan' : 'volcano' : "blue"
  }, RMData.length > 0 ? RMData[0].rmauditpercent ? RMData[0].rmauditpercent : "Pending" : "Pending"))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 14,
    sm: 14,
    md: 14,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("h4", null, "English ", _RmName.default.name, " Audit : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 10,
    sm: 10,
    md: 10,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    className: "mr-0",
    color: RMData.length > 0 ? RMData[0].RMAuditPercentEnglish ? 'cyan' : 'volcano' : "blue"
  }, RMData.length > 0 ? RMData[0].RMAuditPercentEnglish ? RMData[0].RMAuditPercentEnglish : "Pending" : "Pending"))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 14,
    sm: 14,
    md: 14,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Parent Audit : ")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 10,
    sm: 10,
    md: 10,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    className: "mr-0",
    color: RMData.length > 0 ? RMData[0].parentauditpercent ? 'cyan' : 'volcano' : "blue"
  }, RMData.length > 0 ? RMData[0].parentauditpercent ? RMData[0].parentauditpercent : "Pending" : "Pending")))), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "No Audit Response Form",
    visible: showFormData,
    onOk: showForm,
    cancelButtonProps: {
      hidden: true
    },
    okButtonProps: {
      hidden: true
    },
    onCancel: function onCancel() {
      return setShowFormData(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_AuditForm.default, {
    MathsRMCode: RMData.length > 0 ? RMData[0].rmcode : "",
    EnglishRMCode: RMData.length > 0 ? RMData[0].RMcodeEnglish : "",
    RMData: RMData
  }))));
};

var _default = Audit;
exports.default = _default;